export const defaultColors = [
    {
        background: "#5890DC",
        border: "#2D74D3",
    },
    {
        background: "#3AA3E3",
        border: "#098CDC",
    },
    {
        background: "#006ECC",
        border: "#045AA3",
    },
    {
        background: "#0054B4",
        border: "#014593",
    },
    {
        background: "#84BF70",
        border: "#61A649",
    },
    {
        background: "#009492",
        border: "#157B7A",
    },
    {
        background: "#009C5A",
        border: "#04864F",
    },
    {
        background: "#005A3A",
        border: "#054830",
    },
    {
        background: "#BD69BC",
        border: "#AD44AB",
    },
    {
        background: "#CB61C8",
        border: "#9E3C9C",
    },
    {
        background: "#E94C93",
        border: "#AC3C6E",
    },
    {
        background: "#E54D54",
        border: "#BA282E",
    },
    {
        background: "#FF8750",
        border: "#BD4E1B",
    },
    {
        background: "#DC9F54",
        border: "#B87728",
    },
    {
        background: "#E67400",
        border: "#B65F06",
    },
    {
        background: "#9585EF",
        border: "#7A67EB",
    },
    {
        background: "#7366CC",
        border: "#4536AD",
    },
    {
        background: "#3537A6",
        border: "#282A8A",
    },
    {
        background: "#3E3A98",
        border: "#36337E",
    },
    {
        background: "#3D446F",
        border: "#2A2F50",
    },
    {
        background: "#454555",
        border: "#363645",
    },
];
export const defaultCalendars = [
    // default types just for current data. TODO: change to common types like Holidays, Personal...
    {
        id: "work",
        active: true,
        label: "Work",
        color: {
            background: "#3AA3E3",
            border: "#098CDC",
        },
    },
    {
        id: "meeting",
        active: true,
        label: "Meeting",
        color: {
            background: "#9585EF",
            border: "#7A67EB",
        },
    },
    {
        id: "rest",
        active: true,
        label: "Rest",
        color: {
            background: "#BD69BC",
            border: "#AD44AB",
        },
    },
    {
        id: "movie",
        active: true,
        label: "Movie",
        color: {
            background: "#84BF70",
            border: "#61A649",
        },
    },
];
export const defaultEditorShape = [
    {
        key: "text",
        type: "text",
        label: "Event name",
        config: {
            placeholder: "New Event",
        },
    },
    {
        type: "date",
        key: "start_date",
        label: "Start date",
        time: true,
    },
    {
        type: "date",
        key: "end_date",
        label: "End date",
        time: true,
    },
    {
        type: "checkbox",
        key: "allDay",
        text: "All day",
    },
    {
        type: "combo",
        key: "type",
        label: "Type",
    },
    {
        key: "details",
        type: "textarea",
        label: "Description",
        config: {
            placeholder: "Add description",
        },
    },
    {
        type: "recurring",
        key: "recurring",
        label: "Repeat event",
    },
];
export const defaultWeekConfig = {
    eventMargin: "3px",
    columnPadding: "8px",
};
export const defaultMonthConfig = {
    maxEventsPerCell: 4,
};
export const defaultTimelineConfig = {
    colsCount: 90,
    minEventWidth: 50,
    colsWidth: 90,
    minSectionHeight: 100,
    sectionWidth: 158,
    step: [1, "day"],
    key: "section",
    header: [
        { unit: "month", step: 1, format: "MMM" },
        { unit: "day", step: 1, format: "d MMM" },
    ],
    sections: [
        { id: "1", label: "Section 1" },
        { id: "2", label: "Section 2" },
        { id: "3", label: "Section 3" },
        { id: "4", label: "Section 4" },
        { id: "5", label: "Section 5" },
        { id: "6", label: "Section 6" },
        { id: "7", label: "Section 7" },
        { id: "8", label: "Section 8" },
        { id: "9", label: "Section 9" },
    ],
    unassignedCol: false,
};
export const defaultConfig = {
    timeRange: [0, 24],
    timeStep: 5,
    tableHeaderHeight: 32,
    dimPastEvents: false,
    readonly: false,
    dragCreate: true,
    autoSave: false,
    dragMove: true,
    dragResize: true,
    eventInfoOnClick: true,
    editorOnDblClick: true,
    eventsOverlay: false,
    createEventOnDblClick: true,
    eventHeight: 24,
    defaultEventDuration: 60,
    viewControl: "auto",
    views: [
        {
            id: "week",
            label: "Week",
            config: defaultWeekConfig,
            layout: "week",
        },
        { id: "day", label: "Day", config: defaultWeekConfig, layout: "day" },
        {
            id: "month",
            label: "Month",
            config: defaultMonthConfig,
            layout: "month",
        },
        { id: "year", label: "Year", layout: "year" },
        { id: "agenda", label: "Agenda", layout: "agenda" },
    ],
};
//# sourceMappingURL=consts.js.map